import { ReactNode, SelectHTMLAttributes } from "react";

type AppSelectProps = SelectHTMLAttributes<HTMLSelectElement> & {
  children: ReactNode;
};

function joinClassNames(...classes: Array<string | undefined>) {
  return classes.filter(Boolean).join(" ");
}

export default function AppSelect({
  children,
  className,
  ...props
}: AppSelectProps) {
  return (
    <select className={joinClassNames("app-select", className)} {...props}>
      {children}
    </select>
  );
}

